class Direccion
{
  calle = undefined;
  cliente_idClienteSAP = undefined;
  codigoPostal = undefined;
  colonia = undefined;
  delegacionMunicipio = undefined;
  estado = undefined;
  existe = false;
  idDireccion = undefined;
  idioma = undefined;
  numExterior = undefined;
  numInterior = undefined;
  pais = undefined;
  referenciaAdicional = undefined;
  telefono1 = undefined;
  telefono2 = undefined;
  $t = str => str;

  constructor(obj = {}) {
    Object.assign(this, obj);
  }

  get text()
  {
    let parts = [
      [this.$t('Calle'), this.calle],
      [this.$t('Numero exterior'), this.numExterior],
      [this.$t('Numero interior'), this.numInterior],
      [this.$t('Colonia'), this.colonia],
      [this.$t(''), this.delegacionMunicipio],
      [this.$t(''), this.estado],
      [this.$t(''), this.pais],
    ];

    let response = [];
    for (let part of parts)
    {
      let info = part[1];
      if (!!info)
      {
        response.push( `${part[0]} ${info}` );
      }
    }

    return response.join(', ');
  }
}

module.exports = {Direccion};
